import React from 'react'
import { Redirect } from 'react-router-dom'

import { Routes } from '../../navigation/config/routes'

export const VoiceAgentSettings: React.FC = () => (
    <Redirect to={`${Routes.manage.voiceAgent.root}?tab=agent`} />
)
